export default __webpack_public_path__ + "static/media/Letters2_17.d9bb6c29.png";